import { render, staticRenderFns } from "./TopDeals.vue?vue&type=template&id=5a00c777&scoped=true"
import script from "./TopDeals.vue?vue&type=script&setup=true&lang=js"
export * from "./TopDeals.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TopDeals.vue?vue&type=style&index=0&id=5a00c777&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a00c777",
  null
  
)

export default component.exports